import React from 'react'
import { getInjectionMouldingDayColumns } from './getInjectionMouldingDayColumns'
import { getExtrutionDayColumns } from './extrutionDayColumns'
import { punchPressDayColumns } from './punchPressDayColumns'
import { cncDayColumns } from './cncDayColumns'

const daySummaryColumns = (templateType) => {
    switch (templateType) {
        case 1:
          return  getInjectionMouldingDayColumns()
        case 2:
           return getExtrutionDayColumns()
        case 3:
          return punchPressDayColumns()
        case 4:
          return cncDayColumns()
    }
}

export default daySummaryColumns